// Function to extract error messages from the error object
export const extractErrorMessages = errors => {
    const messages = [];
    const result = [];
    errors?.forEach(errorObj => {
        Object.values(errorObj).forEach(errorArray => {
            const errorKey = Object.keys(errorObj)[0];
            if (Array.isArray(errorArray)) {
                errorArray.forEach(message => {
                    if (typeof message === "string") {
                        messages.push(message);
                        result.push({
                            key: errorKey,
                            message: message,
                        });
                    }
                });
            }
        });
    });
    return { messages, result };
};
